import * as React from "react";
import { Coordinates, EllipseCoordinates } from "../../../api/patientScans";

interface ProstateTumorRemovedImageProps {
  tumors: { [key: string]: Coordinates | EllipseCoordinates };
  onPointerMove: (event: React.PointerEvent) => void;
  onPointerLeave: () => void;
  onAffectedAreaClick: React.MouseEventHandler<SVGSVGElement>;
  onTumorClick: React.MouseEventHandler<SVGCircleElement>;
  onContextMenu: React.MouseEventHandler<SVGCircleElement>;
  markerColor: string;
}

const ProstateTumorRemovedImage = React.forwardRef<
  SVGSVGElement,
  ProstateTumorRemovedImageProps
>(
  (
    {
      tumors,
      onPointerMove,
      onPointerLeave,
      onAffectedAreaClick,
      onTumorClick,
      onContextMenu,
      markerColor,
    },
    ref
  ) => (
    <svg
      id="ProstateTumorImage"
      ref={ref}
      viewBox="0 0 1024 768"
      width="100%"
      height="100%"
      fill="none"
      style={{ maxHeight: "77vh" }}
      onPointerMove={onPointerMove}
      onPointerLeave={onPointerLeave}
      onClick={onAffectedAreaClick}
    >
      <g id="Prostate Removed">
        <rect width={1024} height={768} fill="white" />
        <mask
          id="mask0_PROSTATEREMOVED"
          style={{
            maskType: "alpha",
          }}
          maskUnits="userSpaceOnUse"
          x={166}
          y={36}
          width={692}
          height={693}
        >
          <circle
            id="Ellipse 71"
            cx={512}
            cy={382.425}
            r={346}
            fill="#FF0000"
          />
        </mask>
        <g mask="url(#mask0_PROSTATEREMOVED)">
          <g id="Group 94">
            <rect
              id="Rectangle 57"
              x={-27}
              y={82.4539}
              width={928.442}
              height={942.056}
              fill="#FCFCFC"
            />
            <g id="Group 90">
              <g
                id="Vector 83"
                opacity={0.5}
                filter="url(#filter0_f_PROSTATEREMOVED)"
              >
                <path
                  d="M909.61 628.356C909.61 235.606 792.794 241.605 774.836 119.21C424.383 -13.4855 265.738 17.853 137.043 181.833L411.911 1266L894.399 1235.28C832.966 839.747 768.128 789.637 909.61 628.356Z"
                  fill="url(#paint0_linear_PROSTATEREMOVED)"
                />
              </g>
              <g
                id="Vector 86"
                opacity={0.8}
                filter="url(#filter1_f_PROSTATEREMOVED)"
              >
                <path
                  d="M827.092 612.768C695.767 844.878 403.654 744.606 280 700.5L624.407 23.916C639.455 68.0732 654.906 105.511 670.24 138.495L734.676 45.6976C813.568 277.194 816.897 367.087 822.937 519.744C825.644 547.527 827.092 578.257 827.092 612.768Z"
                  fill="url(#paint1_linear_PROSTATEREMOVED)"
                />
              </g>
              <g id="Mask group">
                <g id="Vector 85" filter="url(#filter2_f_PROSTATEREMOVED)">
                  <path
                    d="M160.036 394.449C123.743 336.985 85.3708 -23.1542 107.109 -88.8402C223.36 -196.585 864.817 -82.7906 870.131 -9.43723C906.046 486.283 854.288 347.935 833.5 510.5C817.779 633.444 601.233 656.925 474.493 654.14C437.353 653.323 399.7 678.284 409.775 714.041C419.207 747.513 438.94 776.091 429.398 841.967C414.748 943.096 259.275 915.214 228.558 833.461C203.984 768.058 226.825 665.701 241.317 622.697L172.323 659.085C156.256 653.571 124.783 637.063 127.429 615.136C130.737 587.728 221.946 583.537 190.753 544.252C127.429 464.5 149 394.449 160.036 394.449Z"
                    fill="url(#paint2_linear_PROSTATEREMOVED)"
                  />
                </g>
              </g>
              <g
                id="Vector 87"
                opacity={0.1}
                filter="url(#filter3_f_PROSTATEREMOVED)"
              >
                <path
                  d="M288.101 686.636C295.032 679.39 315.982 662.535 336.775 673.877C362.766 688.054 364.656 689.944 364.656 731.057C364.656 772.17 368.609 877.601 383.559 868.101C434.123 835.966 371.744 699.868 383.559 651.194"
                  stroke="#919191"
                  strokeWidth={11.9006}
                />
              </g>
              <g id="Vector 79" filter="url(#filter4_f_PROSTATEREMOVED)">
                <path
                  d="M267.385 539.63C316.053 536.238 384.811 529.736 413.107 526.909L534.778 584.86C509.312 642.81 393.3 651.291 309.828 634.33C226.356 617.368 217.867 641.397 205.134 658.358C194.948 671.927 188.157 761.538 189.572 808.181C196.646 830.795 198.06 860.477 166.935 873.198C135.81 885.919 106.099 846.343 90.5369 823.728C78.0869 805.637 89.1221 784.152 96.196 775.672C95.7244 785.095 97.0448 779.347 106.099 680.973C117.418 558.005 206.549 543.87 267.385 539.63Z"
                  fill="url(#paint3_linear_PROSTATEREMOVED)"
                />
              </g>
              <g
                id="Ellipse 66"
                opacity={0.1}
                filter="url(#filter5_f_PROSTATEREMOVED)"
              >
                <path
                  d="M308.076 384.758C339.201 415.883 366.556 445.528 349.449 462.636C332.341 479.743 288.094 473.075 256.969 441.949C225.843 410.824 195.453 387.866 222.897 360.421C240.005 343.314 276.951 353.633 308.076 384.758Z"
                  fill="#919191"
                />
              </g>
              <g
                id="Ellipse 71_2"
                opacity={0.1}
                filter="url(#filter6_f_PROSTATEREMOVED)"
              >
                <path
                  d="M688.63 596.984C712.37 594.343 752.548 593.952 754 607C743 620 728 627.5 695.544 638.028C671.804 640.669 647.5 643.972 632 641C630.548 627.952 664.889 599.625 688.63 596.984Z"
                  fill="#919191"
                />
              </g>
              <g
                id="Ellipse 68"
                opacity={0.1}
                filter="url(#filter7_f_PROSTATEREMOVED)"
              >
                <path
                  d="M354.404 771.548C371.026 799.492 379.727 861.485 340.449 861.485C301.171 861.485 254.638 839.228 254.638 792.604C254.638 745.979 244.007 685.407 315.194 673.784C386.382 662.16 364.584 729.749 354.404 771.548Z"
                  fill="#919191"
                />
              </g>
              <g
                id="Vector 82"
                opacity={0.1}
                filter="url(#filter8_f_PROSTATEREMOVED)"
              >
                <path
                  d="M161.453 874.717C152.316 808.4 143.023 682.856 174.434 631.346C206.565 578.654 254.769 578.419 328.489 586.453C402.209 594.486 509.732 569.441 514.458 501.864C518.239 447.803 516.033 329.536 514.458 282.594"
                  stroke="#919191"
                  strokeWidth={11.9006}
                />
              </g>
              <g id="PFM-Left">
                <g id="Rectangle 18" filter="url(#filter9_d_PROSTATEREMOVED)">
                  <rect
                    x={611.711}
                    y={560.07}
                    width={45.1988}
                    height={101.033}
                    rx={10.2005}
                    transform="rotate(109.047 611.711 560.07)"
                    fill="white"
                  />
                </g>
                <path
                  id="PFM"
                  d="M548.344 557.506C547.879 558.849 547.029 559.808 545.793 560.384C544.578 560.949 543.029 560.906 541.145 560.255L538.042 559.182L535.712 565.921L533.604 565.193L539.184 549.051L544.395 550.852C546.217 551.482 547.447 552.399 548.085 553.605C548.738 554.816 548.824 556.116 548.344 557.506ZM541.745 558.518C542.919 558.923 543.872 558.967 544.603 558.65C545.335 558.333 545.864 557.703 546.19 556.761C546.878 554.77 546.08 553.379 543.795 552.589L540.692 551.516L538.642 557.445L541.745 558.518ZM561.721 556.841L561.129 558.555L554.111 556.129L552.23 561.572L557.927 563.541L557.335 565.255L551.637 563.285L549.124 570.558L547.016 569.829L552.596 553.687L561.721 556.841ZM580.6 563.497L575.06 579.523L572.953 578.795L577.084 566.845L567.626 576.954L566.144 576.441L564.933 562.618L560.794 574.592L558.686 573.863L564.226 557.837L566.496 558.621L567.846 573.918L578.354 562.72L580.6 563.497Z"
                  fill="#686868"
                />
              </g>
              <g id="PFM-Right">
                <g id="Rectangle 17" filter="url(#filter10_d_PROSTATEREMOVED)">
                  <rect
                    x={450.995}
                    y={504.538}
                    width={45.1988}
                    height={99.7033}
                    rx={10.2005}
                    transform="rotate(109.047 450.995 504.538)"
                    fill="white"
                  />
                </g>
                <path
                  id="PFM_2"
                  d="M387.487 502.57C387.012 503.909 386.154 504.861 384.913 505.427C383.693 505.982 382.144 505.926 380.266 505.259L377.172 504.161L374.787 510.881L372.685 510.136L378.398 494.04L383.594 495.884C385.41 496.528 386.632 497.456 387.26 498.667C387.903 499.883 387.979 501.184 387.487 502.57ZM380.881 503.528C382.051 503.943 383.003 503.995 383.738 503.683C384.472 503.372 385.006 502.747 385.34 501.808C386.044 499.822 385.257 498.424 382.979 497.616L379.884 496.517L377.786 502.429L380.881 503.528ZM400.87 502.015L400.263 503.724L393.266 501.24L391.34 506.667L397.021 508.683L396.414 510.392L390.734 508.376L388.16 515.627L386.059 514.882L391.771 498.786L400.87 502.015ZM419.694 508.825L414.022 524.806L411.921 524.06L416.15 512.144L406.609 522.175L405.131 521.651L404.034 507.818L399.797 519.757L397.695 519.012L403.367 503.031L405.63 503.834L406.854 519.142L417.454 508.03L419.694 508.825Z"
                  fill="#686868"
                />
              </g>
              <g id="ES">
                <g id="Rectangle 19" filter="url(#filter11_d_PROSTATEREMOVED)">
                  <rect
                    x={508.106}
                    y={524.493}
                    width={45.1988}
                    height={51.8457}
                    rx={10.2005}
                    transform="rotate(109.047 508.106 524.493)"
                    fill="white"
                  />
                </g>
                <path
                  id="ES-Text"
                  d="M469.422 528.925L467.55 534.319L473.43 536.36L472.827 538.096L466.947 536.055L465.019 541.611L471.594 543.893L470.991 545.629L462.31 542.616L467.918 526.458L476.599 529.47L475.996 531.207L469.422 528.925ZM479.239 548.673C478.174 548.303 477.281 547.786 476.561 547.121C475.861 546.446 475.388 545.694 475.139 544.864C474.897 544.019 474.92 543.154 475.21 542.269L477.456 543.048C477.27 543.831 477.357 544.579 477.715 545.291C478.094 545.993 478.808 546.526 479.857 546.89C480.86 547.239 481.733 547.265 482.476 546.969C483.239 546.663 483.757 546.117 484.03 545.33C484.244 544.712 484.249 544.152 484.043 543.648C483.837 543.145 483.515 542.704 483.075 542.327C482.636 541.949 482.024 541.495 481.24 540.963C480.271 540.316 479.511 539.741 478.959 539.238C478.423 538.741 478.025 538.119 477.766 537.371C477.527 536.614 477.582 535.734 477.93 534.731C478.235 533.851 478.729 533.15 479.413 532.626C480.096 532.102 480.903 531.794 481.834 531.702C482.781 531.616 483.779 531.755 484.828 532.119C486.341 532.644 487.444 533.45 488.138 534.539C488.848 535.632 489.048 536.826 488.738 538.119L486.423 537.315C486.56 536.671 486.423 536.018 486.013 535.357C485.608 534.681 484.934 534.179 483.993 533.852C483.113 533.547 482.315 533.529 481.599 533.8C480.888 534.054 480.391 534.591 480.107 535.409C479.903 535.995 479.899 536.53 480.095 537.013C480.306 537.501 480.616 537.928 481.025 538.295C481.454 538.652 482.066 539.106 482.86 539.658C483.823 540.321 484.578 540.912 485.124 541.43C485.676 541.932 486.079 542.565 486.333 543.328C486.593 544.075 486.546 544.958 486.192 545.976C485.919 546.763 485.454 547.432 484.796 547.982C484.138 548.532 483.325 548.881 482.357 549.029C481.389 549.177 480.35 549.059 479.239 548.673Z"
                  fill="#686868"
                />
              </g>
              <g
                id="Ellipse 70"
                opacity={0.1}
                filter="url(#filter12_f_PROSTATEREMOVED)"
              >
                <path
                  d="M938 426.266C842.258 467.504 740.5 474.766 691.5 605.766C677.437 598.616 660.919 501.287 667 447.267C648.673 447.267 880.135 88.2665 446 29.7665C446 -21.2707 772.53 97.1958 801.932 97.1953C820.259 97.1953 938 375.229 938 426.266Z"
                  fill="#919191"
                />
              </g>
            </g>
            <g id="Rectum">
              <path
                id="Intersect"
                d="M777.751 -140.431C773.873 -147.154 756.306 -148.366 751.179 -142.539C711.732 -97.7104 604.402 13.3259 588.081 38.4338C586.366 41.0725 588.006 43.6145 590.993 44.6047C772.657 104.819 746.671 299.938 656.049 431.596C621.783 481.377 614.642 563.018 664.196 598.406C665.41 599.273 666.406 600.408 667.035 601.762C669.74 607.588 677.546 624.417 681.732 633.575C683.318 637.045 687.083 639.112 690.838 638.435C695.165 637.654 698.424 636.961 700.734 636.423C703.522 635.774 705.669 633.542 705.439 630.688C704.586 620.08 696.193 603.288 697.162 593.112C703.78 523.654 754.496 490.553 803.016 445.773C905.33 351.345 966.371 186.587 777.751 -140.431Z"
                fill="url(#paint4_linear_PROSTATEREMOVED)"
              />
              <path
                id="Rectum_2"
                d="M722.878 398.331L718.81 391.347H716.115V398.331H713.885V381.252H719.398C720.689 381.252 721.775 381.472 722.657 381.913C723.556 382.354 724.226 382.951 724.667 383.702C725.108 384.454 725.328 385.311 725.328 386.275C725.328 387.451 724.985 388.489 724.299 389.387C723.629 390.286 722.617 390.882 721.261 391.176L725.549 398.331H722.878ZM716.115 389.559H719.398C720.607 389.559 721.514 389.265 722.118 388.676C722.723 388.072 723.025 387.272 723.025 386.275C723.025 385.262 722.723 384.478 722.118 383.923C721.53 383.367 720.623 383.089 719.398 383.089H716.115V389.559ZM741.045 391.102C741.045 391.527 741.021 391.976 740.972 392.45H730.239C730.321 393.773 730.77 394.811 731.587 395.562C732.42 396.297 733.425 396.665 734.601 396.665C735.565 396.665 736.365 396.444 737.002 396.003C737.656 395.546 738.113 394.941 738.374 394.19H740.776C740.416 395.481 739.698 396.534 738.619 397.351C737.541 398.151 736.202 398.552 734.601 398.552C733.327 398.552 732.183 398.266 731.17 397.694C730.174 397.122 729.389 396.314 728.818 395.268C728.246 394.206 727.96 392.981 727.96 391.592C727.96 390.204 728.238 388.987 728.793 387.941C729.349 386.896 730.125 386.095 731.121 385.54C732.134 384.968 733.294 384.682 734.601 384.682C735.875 384.682 737.002 384.96 737.982 385.515C738.963 386.071 739.714 386.839 740.237 387.819C740.776 388.783 741.045 389.877 741.045 391.102ZM738.742 390.637C738.742 389.787 738.554 389.06 738.178 388.456C737.803 387.835 737.288 387.37 736.635 387.059C735.997 386.732 735.287 386.569 734.503 386.569C733.376 386.569 732.412 386.928 731.611 387.647C730.827 388.366 730.378 389.363 730.263 390.637H738.742ZM743.156 391.592C743.156 390.204 743.433 388.995 743.989 387.966C744.544 386.92 745.312 386.112 746.292 385.54C747.289 384.968 748.424 384.682 749.698 384.682C751.348 384.682 752.704 385.082 753.766 385.883C754.844 386.683 755.555 387.794 755.898 389.216H753.496C753.268 388.399 752.818 387.753 752.149 387.28C751.495 386.806 750.678 386.569 749.698 386.569C748.424 386.569 747.395 387.01 746.611 387.892C745.827 388.758 745.435 389.992 745.435 391.592C745.435 393.21 745.827 394.459 746.611 395.342C747.395 396.224 748.424 396.665 749.698 396.665C750.678 396.665 751.495 396.436 752.149 395.979C752.802 395.521 753.251 394.868 753.496 394.018H755.898C755.538 395.391 754.82 396.493 753.741 397.326C752.663 398.143 751.316 398.552 749.698 398.552C748.424 398.552 747.289 398.266 746.292 397.694C745.312 397.122 744.544 396.314 743.989 395.268C743.433 394.223 743.156 392.997 743.156 391.592ZM761.593 386.741V394.656C761.593 395.309 761.732 395.775 762.01 396.052C762.288 396.314 762.769 396.444 763.456 396.444H765.097V398.331H763.088C761.846 398.331 760.915 398.045 760.294 397.474C759.674 396.902 759.363 395.962 759.363 394.656V386.741H757.624V384.903H759.363V381.521H761.593V384.903H765.097V386.741H761.593ZM779.708 384.903V398.331H777.478V396.346C777.054 397.032 776.457 397.572 775.69 397.964C774.938 398.339 774.105 398.527 773.19 398.527C772.145 398.527 771.205 398.315 770.372 397.89C769.539 397.449 768.877 396.796 768.387 395.93C767.913 395.064 767.677 394.01 767.677 392.769V384.903H769.882V392.475C769.882 393.798 770.217 394.819 770.887 395.538C771.556 396.24 772.471 396.591 773.631 396.591C774.824 396.591 775.763 396.224 776.449 395.489C777.135 394.754 777.478 393.684 777.478 392.279V384.903H779.708ZM799.622 384.658C800.667 384.658 801.598 384.878 802.415 385.319C803.232 385.744 803.877 386.389 804.351 387.255C804.825 388.121 805.062 389.175 805.062 390.416V398.331H802.856V390.735C802.856 389.395 802.521 388.374 801.852 387.672C801.198 386.953 800.308 386.594 799.181 386.594C798.021 386.594 797.098 386.969 796.412 387.721C795.725 388.456 795.382 389.526 795.382 390.931V398.331H793.177V390.735C793.177 389.395 792.842 388.374 792.172 387.672C791.519 386.953 790.629 386.594 789.501 386.594C788.342 386.594 787.419 386.969 786.732 387.721C786.046 388.456 785.703 389.526 785.703 390.931V398.331H783.473V384.903H785.703V386.839C786.144 386.136 786.732 385.597 787.468 385.221C788.219 384.846 789.044 384.658 789.942 384.658C791.07 384.658 792.066 384.911 792.932 385.417C793.798 385.924 794.443 386.667 794.868 387.647C795.244 386.7 795.864 385.965 796.73 385.442C797.596 384.919 798.56 384.658 799.622 384.658Z"
                fill="#686868"
              />
            </g>
            <g id="SV">
              <g id="Group 97">
                <g id="Group">
                  <g id="Vector" filter="url(#filter13_d_PROSTATEREMOVED)">
                    <path
                      d="M593.602 167.577C585.919 167.577 579.69 173.805 579.69 181.488L579.69 288.142C579.69 295.825 585.919 302.053 593.602 302.053L624.902 302.053L624.902 168.736C624.902 168.096 625.421 167.577 626.061 167.577L593.602 167.577Z"
                      fill="white"
                    />
                  </g>
                  <path
                    id="R"
                    d="M606.166 268.01L602.099 261.026H599.403V268.01H597.173V250.93H602.687C603.977 250.93 605.064 251.151 605.946 251.592C606.844 252.033 607.514 252.629 607.955 253.381C608.396 254.132 608.617 254.99 608.617 255.954C608.617 257.13 608.274 258.167 607.588 259.066C606.918 259.964 605.905 260.561 604.549 260.855L608.837 268.01H606.166ZM599.403 259.237H602.687C603.896 259.237 604.802 258.943 605.407 258.355C606.011 257.751 606.313 256.95 606.313 255.954C606.313 254.941 606.011 254.157 605.407 253.601C604.819 253.046 603.912 252.768 602.687 252.768H599.403V259.237Z"
                    fill="#686868"
                  />
                </g>
                <g id="Group_2">
                  <g
                    id="Rounded rectangle"
                    filter="url(#filter14_d_PROSTATEREMOVED)"
                  >
                    <path
                      d="M624.903 168.427C624.903 167.958 625.284 167.577 625.753 167.577H659.915C665.548 167.577 670.115 172.144 670.115 177.778V291.853C670.115 297.487 665.548 302.054 659.915 302.054H624.903V168.427Z"
                      fill="white"
                    />
                  </g>
                  <path
                    id="L"
                    d="M645.555 266.197H651.534V268.01H643.325V250.931H645.555V266.197Z"
                    fill="#686868"
                  />
                </g>
                <path
                  id="SVB"
                  d="M607.898 231.367C606.771 231.367 605.758 231.171 604.86 230.778C603.978 230.37 603.283 229.815 602.777 229.112C602.27 228.393 602.009 227.568 601.993 226.637H604.37C604.451 227.438 604.778 228.116 605.35 228.671C605.938 229.21 606.787 229.48 607.898 229.48C608.96 229.48 609.793 229.218 610.398 228.696C611.019 228.157 611.329 227.47 611.329 226.637C611.329 225.984 611.149 225.453 610.79 225.044C610.43 224.636 609.981 224.326 609.442 224.113C608.903 223.901 608.176 223.672 607.261 223.427C606.134 223.133 605.227 222.839 604.541 222.545C603.871 222.251 603.291 221.794 602.801 221.173C602.328 220.536 602.091 219.686 602.091 218.624C602.091 217.693 602.328 216.868 602.801 216.149C603.275 215.431 603.937 214.875 604.786 214.483C605.652 214.091 606.64 213.895 607.751 213.895C609.352 213.895 610.659 214.295 611.672 215.096C612.701 215.896 613.281 216.958 613.412 218.281H610.961C610.88 217.628 610.537 217.056 609.932 216.566C609.328 216.06 608.527 215.806 607.531 215.806C606.6 215.806 605.84 216.051 605.252 216.541C604.664 217.015 604.37 217.685 604.37 218.551C604.37 219.172 604.541 219.678 604.884 220.07C605.244 220.462 605.677 220.764 606.183 220.977C606.706 221.173 607.433 221.401 608.364 221.663C609.491 221.973 610.398 222.284 611.084 222.594C611.77 222.888 612.358 223.354 612.848 223.991C613.338 224.612 613.583 225.461 613.583 226.539C613.583 227.372 613.363 228.157 612.922 228.892C612.481 229.627 611.827 230.223 610.961 230.68C610.096 231.138 609.075 231.367 607.898 231.367ZM630.979 214.116L624.535 231.195H621.962L615.517 214.116H617.894L623.26 228.843L628.627 214.116H630.979ZM641.976 222.398C642.597 222.496 643.161 222.749 643.667 223.158C644.19 223.566 644.598 224.072 644.892 224.677C645.203 225.281 645.358 225.927 645.358 226.613C645.358 227.479 645.137 228.263 644.696 228.965C644.255 229.651 643.61 230.199 642.761 230.607C641.927 230.999 640.939 231.195 639.795 231.195H633.424V214.116H639.55C640.71 214.116 641.699 214.312 642.515 214.704C643.332 215.079 643.945 215.594 644.353 216.247C644.762 216.901 644.966 217.636 644.966 218.453C644.966 219.466 644.688 220.307 644.133 220.977C643.594 221.63 642.875 222.104 641.976 222.398ZM635.654 221.491H639.403C640.449 221.491 641.258 221.246 641.829 220.756C642.401 220.266 642.687 219.588 642.687 218.722C642.687 217.857 642.401 217.179 641.829 216.688C641.258 216.198 640.433 215.953 639.354 215.953H635.654V221.491ZM639.599 229.357C640.71 229.357 641.576 229.096 642.197 228.573C642.818 228.05 643.128 227.323 643.128 226.392C643.128 225.445 642.801 224.701 642.148 224.162C641.494 223.607 640.62 223.329 639.526 223.329H635.654V229.357H639.599Z"
                  fill="#686868"
                />
              </g>
              <path
                id="SVB-Left"
                d="M625 167L660 167C665.523 167 670 171.477 670 177L670 292C670 297.523 665.523 302 660 302L625 302L625 167Z"
                fill="white"
                fillOpacity={0.01}
              />
              <path
                id="SVB-Right"
                d="M625 167H594C586.268 167 580 173.268 580 181V288C580 295.732 586.268 302 594 302H625V167Z"
                fill="white"
                fillOpacity={0.01}
              />
            </g>
            <g id="Bladder" filter="url(#filter15_d_PROSTATEREMOVED)">
              <path
                id="Vector 77"
                d="M547.755 300.316C571.798 177.97 546.328 135.947 434.225 143.406C364.506 148.045 286.274 172.644 251.06 200.223C236.561 211.578 229.354 223.438 233.039 234.618C238.673 251.715 257.062 267.248 282.367 281.632C337.626 313.044 404.661 339.039 467.119 351.557C507.83 359.717 537.629 351.843 547.755 300.316Z"
                fill="white"
              />
              <path
                id="Bladder_2"
                d="M369.193 238.491C369.813 238.589 370.377 238.842 370.883 239.251C371.406 239.659 371.815 240.165 372.109 240.77C372.419 241.374 372.574 242.02 372.574 242.706C372.574 243.571 372.354 244.356 371.913 245.058C371.472 245.744 370.826 246.291 369.977 246.7C369.144 247.092 368.155 247.288 367.012 247.288L360.641 247.288L360.641 230.208L366.767 230.208C367.927 230.208 368.915 230.404 369.732 230.797C370.549 231.172 371.161 231.687 371.57 232.34C371.978 232.994 372.182 233.729 372.182 234.546C372.182 235.559 371.904 236.4 371.349 237.07C370.81 237.723 370.091 238.197 369.193 238.491ZM362.871 237.584L366.62 237.584C367.665 237.584 368.474 237.339 369.046 236.849C369.617 236.359 369.903 235.681 369.903 234.815C369.903 233.949 369.617 233.271 369.046 232.781C368.474 232.291 367.649 232.046 366.571 232.046L362.871 232.046L362.871 237.584ZM366.816 245.45C367.927 245.45 368.792 245.189 369.413 244.666C370.034 244.143 370.344 243.416 370.344 242.485C370.344 241.538 370.018 240.794 369.364 240.255C368.711 239.7 367.837 239.422 366.742 239.422L362.871 239.422L362.871 245.45L366.816 245.45ZM377.899 229.155L377.899 247.288L375.669 247.288L375.669 229.155L377.899 229.155ZM380.866 240.525C380.866 239.153 381.144 237.952 381.699 236.923C382.254 235.877 383.014 235.068 383.978 234.497C384.958 233.925 386.044 233.639 387.237 233.639C388.413 233.639 389.434 233.892 390.3 234.399C391.166 234.905 391.811 235.542 392.236 236.31L392.236 233.86L394.49 233.86L394.49 247.288L392.236 247.288L392.236 244.789C391.795 245.573 391.133 246.226 390.251 246.749C389.385 247.255 388.372 247.509 387.213 247.509C386.02 247.509 384.942 247.214 383.978 246.626C383.014 246.038 382.254 245.213 381.699 244.151C381.144 243.09 380.866 241.881 380.866 240.525ZM392.236 240.549C392.236 239.536 392.032 238.654 391.623 237.903C391.215 237.151 390.659 236.58 389.957 236.187C389.271 235.779 388.511 235.575 387.678 235.575C386.845 235.575 386.085 235.771 385.399 236.163C384.713 236.555 384.166 237.127 383.757 237.878C383.349 238.63 383.145 239.512 383.145 240.525C383.145 241.554 383.349 242.452 383.757 243.22C384.166 243.972 384.713 244.552 385.399 244.96C386.085 245.352 386.845 245.548 387.678 245.548C388.511 245.548 389.271 245.352 389.957 244.96C390.659 244.552 391.215 243.972 391.623 243.22C392.032 242.452 392.236 241.562 392.236 240.549ZM397.425 240.525C397.425 239.153 397.703 237.952 398.259 236.923C398.814 235.877 399.574 235.068 400.538 234.497C401.518 233.925 402.612 233.639 403.821 233.639C404.867 233.639 405.839 233.884 406.737 234.374C407.636 234.848 408.322 235.477 408.795 236.261L408.795 229.155L411.05 229.155L411.05 247.288L408.795 247.288L408.795 244.764C408.354 245.564 407.701 246.226 406.835 246.749C405.969 247.255 404.956 247.509 403.797 247.509C402.604 247.509 401.518 247.214 400.538 246.626C399.574 246.038 398.814 245.213 398.259 244.151C397.703 243.09 397.425 241.881 397.425 240.525ZM408.795 240.549C408.795 239.536 408.591 238.654 408.183 237.903C407.774 237.151 407.219 236.58 406.517 236.187C405.83 235.779 405.071 235.575 404.238 235.575C403.405 235.575 402.645 235.771 401.959 236.163C401.273 236.555 400.725 237.127 400.317 237.878C399.909 238.63 399.704 239.512 399.704 240.525C399.704 241.554 399.909 242.452 400.317 243.22C400.725 243.972 401.273 244.552 401.959 244.96C402.645 245.352 403.405 245.548 404.238 245.548C405.071 245.548 405.83 245.352 406.517 244.96C407.219 244.552 407.774 243.972 408.183 243.22C408.591 242.452 408.795 241.562 408.795 240.549ZM413.985 240.525C413.985 239.153 414.263 237.952 414.818 236.923C415.374 235.877 416.133 235.068 417.097 234.497C418.077 233.925 419.172 233.639 420.381 233.639C421.426 233.639 422.398 233.884 423.297 234.374C424.195 234.848 424.881 235.477 425.355 236.261L425.355 229.155L427.609 229.155L427.609 247.288L425.355 247.288L425.355 244.764C424.914 245.564 424.261 246.226 423.395 246.749C422.529 247.255 421.516 247.509 420.356 247.509C419.164 247.509 418.077 247.214 417.097 246.626C416.133 246.038 415.374 245.213 414.818 244.151C414.263 243.09 413.985 241.881 413.985 240.525ZM425.355 240.549C425.355 239.536 425.151 238.654 424.742 237.903C424.334 237.151 423.779 236.58 423.076 236.187C422.39 235.779 421.63 235.575 420.797 235.575C419.964 235.575 419.204 235.771 418.518 236.163C417.832 236.555 417.285 237.127 416.877 237.878C416.468 238.63 416.264 239.512 416.264 240.525C416.264 241.554 416.468 242.452 416.877 243.22C417.285 243.972 417.832 244.552 418.518 244.96C419.204 245.352 419.964 245.548 420.797 245.548C421.63 245.548 422.39 245.352 423.076 244.96C423.779 244.552 424.334 243.972 424.742 243.22C425.151 242.452 425.355 241.562 425.355 240.549ZM443.63 240.059C443.63 240.484 443.605 240.933 443.556 241.407L432.824 241.407C432.905 242.73 433.354 243.768 434.171 244.519C435.004 245.254 436.009 245.622 437.185 245.622C438.149 245.622 438.95 245.401 439.587 244.96C440.24 244.503 440.698 243.898 440.959 243.147L443.36 243.147C443.001 244.437 442.282 245.491 441.204 246.308C440.126 247.108 438.786 247.509 437.185 247.509C435.911 247.509 434.768 247.223 433.755 246.651C432.758 246.079 431.974 245.27 431.402 244.225C430.831 243.163 430.545 241.938 430.545 240.549C430.545 239.161 430.822 237.944 431.378 236.898C431.933 235.853 432.709 235.052 433.706 234.497C434.719 233.925 435.878 233.639 437.185 233.639C438.46 233.639 439.587 233.917 440.567 234.472C441.547 235.028 442.299 235.795 442.821 236.776C443.36 237.739 443.63 238.834 443.63 240.059ZM441.327 239.594C441.327 238.744 441.139 238.017 440.763 237.413C440.387 236.792 439.873 236.326 439.219 236.016C438.582 235.689 437.871 235.526 437.087 235.526C435.96 235.526 434.996 235.885 434.196 236.604C433.412 237.323 432.962 238.319 432.848 239.594L441.327 239.594ZM448.803 236.04C449.195 235.273 449.751 234.676 450.47 234.252C451.205 233.827 452.095 233.615 453.141 233.615L453.141 235.918L452.552 235.918C450.053 235.918 448.803 237.274 448.803 239.986L448.803 247.288L446.573 247.288L446.573 233.86L448.803 233.86L448.803 236.04Z"
                fill="#686868"
              />
            </g>
            <path
              id="Penis"
              d="M304.854 583.919C304.854 585.341 304.364 586.525 303.384 587.472C302.42 588.404 300.941 588.869 298.948 588.869L295.665 588.869L295.665 596L293.435 596L293.435 578.92L298.948 578.92C300.876 578.92 302.338 579.386 303.335 580.317C304.348 581.248 304.854 582.449 304.854 583.919ZM298.948 587.031C300.19 587.031 301.105 586.762 301.693 586.223C302.281 585.684 302.575 584.916 302.575 583.919C302.575 581.812 301.366 580.758 298.948 580.758L295.665 580.758L295.665 587.031L298.948 587.031ZM319.878 588.771C319.878 589.196 319.853 589.645 319.804 590.119L309.071 590.119C309.153 591.442 309.602 592.48 310.419 593.231C311.252 593.966 312.257 594.334 313.433 594.334C314.397 594.334 315.197 594.113 315.834 593.672C316.488 593.215 316.945 592.61 317.207 591.859L319.608 591.859C319.249 593.149 318.53 594.203 317.452 595.02C316.373 595.82 315.034 596.221 313.433 596.221C312.159 596.221 311.015 595.935 310.002 595.363C309.006 594.791 308.222 593.982 307.65 592.937C307.078 591.875 306.792 590.65 306.792 589.261C306.792 587.873 307.07 586.656 307.625 585.61C308.181 584.565 308.957 583.764 309.953 583.209C310.966 582.637 312.126 582.351 313.433 582.351C314.707 582.351 315.834 582.629 316.815 583.184C317.795 583.74 318.546 584.507 319.069 585.488C319.608 586.451 319.878 587.546 319.878 588.771ZM317.574 588.306C317.574 587.456 317.386 586.729 317.011 586.125C316.635 585.504 316.12 585.038 315.467 584.728C314.83 584.401 314.119 584.238 313.335 584.238C312.208 584.238 311.244 584.597 310.443 585.316C309.659 586.035 309.21 587.031 309.096 588.306L317.574 588.306ZM329.364 582.327C330.997 582.327 332.32 582.825 333.333 583.821C334.346 584.802 334.853 586.223 334.853 588.085L334.853 596L332.647 596L332.647 588.404C332.647 587.064 332.312 586.043 331.643 585.341C330.973 584.622 330.058 584.262 328.898 584.262C327.722 584.262 326.783 584.63 326.08 585.365C325.394 586.1 325.051 587.17 325.051 588.575L325.051 596L322.821 596L322.821 582.572L325.051 582.572L325.051 584.483C325.492 583.797 326.088 583.266 326.84 582.89C327.607 582.514 328.449 582.327 329.364 582.327ZM339.647 580.391C339.222 580.391 338.863 580.244 338.569 579.95C338.275 579.656 338.128 579.296 338.128 578.871C338.128 578.447 338.275 578.087 338.569 577.793C338.863 577.499 339.222 577.352 339.647 577.352C340.055 577.352 340.398 577.499 340.676 577.793C340.97 578.087 341.117 578.447 341.117 578.871C341.117 579.296 340.97 579.656 340.676 579.95C340.398 580.244 340.055 580.391 339.647 580.391ZM340.725 582.572L340.725 596L338.495 596L338.495 582.572L340.725 582.572ZM349.279 596.221C348.25 596.221 347.327 596.049 346.51 595.706C345.694 595.347 345.048 594.856 344.575 594.236C344.101 593.599 343.839 592.872 343.79 592.055L346.094 592.055C346.159 592.725 346.47 593.272 347.025 593.697C347.597 594.121 348.34 594.334 349.255 594.334C350.104 594.334 350.774 594.146 351.264 593.77C351.754 593.394 351.999 592.921 351.999 592.349C351.999 591.761 351.738 591.328 351.215 591.05C350.692 590.756 349.884 590.47 348.789 590.192C347.793 589.931 346.976 589.67 346.339 589.408C345.718 589.131 345.179 588.73 344.722 588.208C344.28 587.669 344.06 586.966 344.06 586.1C344.06 585.414 344.264 584.785 344.673 584.213C345.081 583.642 345.661 583.192 346.412 582.866C347.164 582.523 348.021 582.351 348.985 582.351C350.472 582.351 351.673 582.727 352.587 583.478C353.502 584.23 353.992 585.259 354.058 586.566L351.828 586.566C351.779 585.863 351.493 585.3 350.97 584.875C350.464 584.45 349.778 584.238 348.912 584.238C348.111 584.238 347.474 584.409 347 584.753C346.527 585.096 346.29 585.545 346.29 586.1C346.29 586.541 346.429 586.909 346.706 587.203C347 587.481 347.36 587.709 347.785 587.889C348.226 588.052 348.83 588.24 349.598 588.453C350.562 588.714 351.346 588.975 351.95 589.237C352.555 589.482 353.069 589.858 353.494 590.364C353.935 590.87 354.164 591.532 354.18 592.349C354.18 593.084 353.976 593.746 353.568 594.334C353.159 594.922 352.579 595.387 351.828 595.73C351.093 596.057 350.243 596.221 349.279 596.221Z"
              fill="#686868"
            />
          </g>
          <g id="RV">
            <g id="Rectangle 17_2" filter="url(#filter16_d_PROSTATEREMOVED)">
              <rect
                x={594.973}
                y={319}
                width={69.6456}
                height={89.9452}
                rx={10.7147}
                transform="rotate(30 594.973 319)"
                fill="white"
              />
            </g>
            <path
              id="RV-Text"
              d="M595.318 384.118L591.25 377.134H588.554V384.118H586.325V367.038H591.838C593.129 367.038 594.215 367.259 595.097 367.7C595.996 368.141 596.665 368.737 597.107 369.489C597.548 370.24 597.768 371.098 597.768 372.062C597.768 373.238 597.425 374.275 596.739 375.174C596.069 376.072 595.056 376.669 593.7 376.963L597.989 384.118H595.318ZM588.554 375.345H591.838C593.047 375.345 593.954 375.051 594.558 374.463C595.162 373.859 595.465 373.058 595.465 372.062C595.465 371.049 595.162 370.265 594.558 369.709C593.97 369.154 593.063 368.876 591.838 368.876H588.554V375.345ZM615.348 367.038L608.903 384.118H606.33L599.885 367.038H602.262L607.629 381.765L612.995 367.038H615.348Z"
              fill="#686868"
            />
          </g>
          <g id="VTA">
            <g id="Rectangle 31" filter="url(#filter17_d_PROSTATEREMOVED)">
              <rect
                x={477}
                y={402.445}
                width={69.429}
                height={92.572}
                rx={10.7147}
                fill="white"
              />
            </g>
            <path
              id="VTA-Text"
              d="M504.813 440.954L498.368 458.034H495.795L489.35 440.954H491.727L497.094 455.681L502.46 440.954H504.813ZM517.77 440.954V442.768H513.114V458.034H510.884V442.768H506.204V440.954H517.77ZM530.611 454.236H523.161L521.789 458.034H519.437L525.612 441.052H528.185L534.335 458.034H531.983L530.611 454.236ZM529.974 452.422L526.886 443.797L523.799 452.422H529.974Z"
              fill="#686868"
            />
          </g>
        </g>
      </g>
      <g id="Tumors">
        {Object.keys(tumors).map((key) => (
          <circle
            key={key}
            id={key}
            cx={(tumors[key] as Coordinates)!.x}
            cy={(tumors[key] as Coordinates)!.y}
            r={15}
            fill={(tumors[key] as Coordinates).color || markerColor}
            fillOpacity={0.5}
            onClick={onTumorClick}
            onContextMenu={onContextMenu}
          />
        ))}
      </g>
      <defs>
        <filter
          id="filter0_f_PROSTATEREMOVED"
          x={126.842}
          y={26.2932}
          width={792.968}
          height={1249.91}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5.10027}
            result="effect1_foregroundBlur_PROSTATEREMOVED"
          />
        </filter>
        <filter
          id="filter1_f_PROSTATEREMOVED"
          x={269.799}
          y={13.7154}
          width={567.494}
          height={756.753}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5.10027}
            result="effect1_foregroundBlur_PROSTATEREMOVED"
          />
        </filter>
        <filter
          id="filter2_f_PROSTATEREMOVED"
          x={90.5807}
          y={-143.282}
          width={802.106}
          height={1060.45}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5.10027}
            result="effect1_foregroundBlur_PROSTATEREMOVED"
          />
        </filter>
        <filter
          id="filter3_f_PROSTATEREMOVED"
          x={273.6}
          y={639.59}
          width={146.176}
          height={245.266}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5.10027}
            result="effect1_foregroundBlur_PROSTATEREMOVED"
          />
        </filter>
        <filter
          id="filter4_f_PROSTATEREMOVED"
          x={74.6969}
          y={516.709}
          width={470.282}
          height={369.153}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5.10027}
            result="effect1_foregroundBlur_PROSTATEREMOVED"
          />
        </filter>
        <filter
          id="filter5_f_PROSTATEREMOVED"
          x={201.989}
          y={342.004}
          width={162.934}
          height={140.033}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5.10027}
            result="effect1_foregroundBlur_PROSTATEREMOVED"
          />
        </filter>
        <filter
          id="filter6_f_PROSTATEREMOVED"
          x={621.755}
          y={585.305}
          width={142.446}
          height={67.0682}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5.10027}
            result="effect1_foregroundBlur_PROSTATEREMOVED"
          />
        </filter>
        <filter
          id="filter7_f_PROSTATEREMOVED"
          x={243.875}
          y={662.259}
          width={134.762}
          height={209.427}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5.10027}
            result="effect1_foregroundBlur_PROSTATEREMOVED"
          />
        </filter>
        <filter
          id="filter8_f_PROSTATEREMOVED"
          x={136.555}
          y={272.194}
          width={396.141}
          height={613.535}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5.10027}
            result="effect1_foregroundBlur_PROSTATEREMOVED"
          />
        </filter>
        <filter
          id="filter9_d_PROSTATEREMOVED"
          x={465.975}
          y={495.014}
          width={181.22}
          height={146.665}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.40018} />
          <feGaussianBlur stdDeviation={19.126} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PROSTATEREMOVED"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PROSTATEREMOVED"
            result="shape"
          />
        </filter>
        <filter
          id="filter10_d_PROSTATEREMOVED"
          x={306.516}
          y={439.916}
          width={179.964}
          height={146.231}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.40018} />
          <feGaussianBlur stdDeviation={19.126} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PROSTATEREMOVED"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PROSTATEREMOVED"
            result="shape"
          />
        </filter>
        <filter
          id="filter11_d_PROSTATEREMOVED"
          x={408.864}
          y={475.489}
          width={134.727}
          height={130.613}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.40018} />
          <feGaussianBlur stdDeviation={19.126} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PROSTATEREMOVED"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PROSTATEREMOVED"
            result="shape"
          />
        </filter>
        <filter
          id="filter12_f_PROSTATEREMOVED"
          x={426}
          y={-3}
          width={532}
          height={628.766}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={10}
            result="effect1_foregroundBlur_PROSTATEREMOVED"
          />
        </filter>
        <filter
          id="filter13_d_PROSTATEREMOVED"
          x={540.716}
          y={132.229}
          width={124.319}
          height={212.424}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.62546} />
          <feGaussianBlur stdDeviation={19.4869} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PROSTATEREMOVED"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PROSTATEREMOVED"
            result="shape"
          />
        </filter>
        <filter
          id="filter14_d_PROSTATEREMOVED"
          x={600.252}
          y={149.726}
          width={80.9137}
          height={170.178}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx={-6.80037} />
          <feGaussianBlur stdDeviation={8.92548} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PROSTATEREMOVED"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PROSTATEREMOVED"
            result="shape"
          />
        </filter>
        <filter
          id="filter15_d_PROSTATEREMOVED"
          x={193.834}
          y={107.723}
          width={400.46}
          height={288.251}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.40018} />
          <feGaussianBlur stdDeviation={19.126} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PROSTATEREMOVED"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PROSTATEREMOVED"
            result="shape"
          />
        </filter>
        <filter
          id="filter16_d_PROSTATEREMOVED"
          x={512.982}
          y={285.79}
          width={179.324}
          height={186.754}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.80821} />
          <feGaussianBlur stdDeviation={20.4691} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PROSTATEREMOVED"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PROSTATEREMOVED"
            result="shape"
          />
        </filter>
        <filter
          id="filter17_d_PROSTATEREMOVED"
          x={436.062}
          y={365.315}
          width={151.305}
          height={174.448}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.80821} />
          <feGaussianBlur stdDeviation={20.4691} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_PROSTATEREMOVED"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_PROSTATEREMOVED"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_PROSTATEREMOVED"
          x1={853.378}
          y1={863.79}
          x2={393.08}
          y2={924.598}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F7F7" />
          <stop offset={1} stopColor="#ECECEC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_PROSTATEREMOVED"
          x1={447.524}
          y1={666.52}
          x2={952.366}
          y2={658.743}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0E0E0" />
          <stop offset={0.760417} stopColor="#F0F0F0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_PROSTATEREMOVED"
          x1={736.041}
          y1={323.582}
          x2={271.062}
          y2={854.079}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAFAFA" />
          <stop offset={1} stopColor="#ECECEC" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_PROSTATEREMOVED"
          x1={380.25}
          y1={691.834}
          x2={457.75}
          y2={572.275}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.584561} stopColor="#E8E8E8" />
          <stop offset={1} stopColor="#E8E8E8" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint4_linear_PROSTATEREMOVED"
          x1={767.574}
          y1={373.371}
          x2={916.431}
          y2={120.549}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="#F9F9F9" />
        </linearGradient>
      </defs>
    </svg>
  )
);

export default ProstateTumorRemovedImage;
